import TAXI_COMPANIES from "../constants/taxi-companies";

export type TaxiCompaniesRepo = {
  api: {
    request: () => any;
    error: (type: string | number, message: string) => any;
    response: (data: any) => any;
  };
};

const TaxiCompanies: TaxiCompaniesRepo = {
  api: {
    request: () => ({
      type: TAXI_COMPANIES.TAXI_COMPANIES_API.SET_REQUEST,
      payload: {},
    }),
    error: (type, message) => ({
      type: TAXI_COMPANIES.TAXI_COMPANIES_API.SET_ERROR,
      payload: { type, message },
    }),
    response: (data) => ({
      type: TAXI_COMPANIES.TAXI_COMPANIES_API.SET_RESPONSE,
      payload: { data },
    }),
  },
};

export default TaxiCompanies;
